// extracted by mini-css-extract-plugin
module.exports = {"header-search-bar-suggestions-column":"header-search-bar-suggestions-column_header-search-bar-suggestions-column__kgPM9"};